import React from 'react';

import { FOR_INVESTORS_SUB_SECTIONS } from 'constants/businessToolSections/forInvestors';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { CompetitiveAnalysisMarket } from './CompetitiveAnalysisMarket';
import { ConsumerNeedsMarket } from './ConsumerNeedsMarket';
import { MarketOverview } from './MarketOverview';
import { IForInvestorFormSubSections } from '../forInvestorsSections';

const SUB_SECTIONS: IForInvestorFormSubSections = {
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_MARKET_ANALYSIS.MARKET_OVERVIEW]: MarketOverview,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_MARKET_ANALYSIS.COMPETITIVE_ANALYSIS]: CompetitiveAnalysisMarket,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_MARKET_ANALYSIS.CONSUMER_NEEDS]: ConsumerNeedsMarket,
};

export const MarketAnalysis: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
